import { AxiosResponse } from 'axios';
import { CallHistoryMethodAction, goBack } from 'connected-react-router';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { ISendLetter } from '../../interfaces/SendLetter';
import { getLocaleMsg } from '../../lngProvider';
import { onSendLetterSuccess } from '../actions';

// sendLetter
const sendLetterApi = async (sendLetterModel: ISendLetter) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`Letter/SendLetter`, sendLetterModel);
};

function* sendLetterRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  CallHistoryMethodAction<[]> | void,
  AxiosResponse<any>
> {
  const messages = getLocaleMsg();
  try {
    const result = yield call(sendLetterApi, action.payload);
    ShowSuccess('', messages['draft.SendLetter']);
    yield put(
      onSendLetterSuccess({
        subject: action.payload.saveLetter.subject,
        letterCode: action.payload.saveLetter.letterCode,
        letterNumber: result.data,
      }),
    );
    return goBack();
  } catch (error) {
    ShowError('', error);
  }
}

export function* SendLetter() {
  yield takeEvery(ActionTypes.SEND_LETTER, sendLetterRequest);
}

export default function* rootSaga() {
  yield all([fork(SendLetter)]);
}
